import { useTranslation } from 'react-i18next';

export const ContributionLegend = ({
  collapsed = false,
}: {
  collapsed?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-3 text-sm mr-4 w-full h-10 pl-2">
      <div>{t('widget.veryBad')}</div>
      <span className={`flex relative h-3 w-${collapsed ? '44' : '88'}`}>
        <div
          className={`
            w-1/2
            rounded-l-full
            bg-gradient-to-r
            from-red-700
            to-red-100
          `}
        />
        <div
          className={`
            w-1/2
            rounded-r-full
            bg-gradient-to-r
            from-red-100
            to-green-700
          `}
        />
        <div
          className={`
            absolute
            top-0
            right-0
            bottom-0
            left-0
            oveflow-hidden
            bg-center
            z-30
            pointer-events-none
            mix-blend-overlay
            rounded-full
          `}
          style={{ backgroundImage: `url('/overlay-bar.svg')` }}
        />
      </span>
      <div>{t('widget.veryGood')}</div>
    </div>
  );
};
